import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import IconButton from '@mui/material/IconButton';
import SvgIcon from '@mui/material/SvgIcon';
import Chip from '@mui/material/Chip';

import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';


import theme from '../theme';

export const CustomBox = styled(Box)(({ theme }) => ({  
  padding: theme.spacing(10),
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(3),
  
  '&.MuiBox-root': {
    [theme.breakpoints.down("lg")]: {
      paddingLeft: theme.spacing(0),
      paddingRight: theme.spacing(0)
    },
    [theme.breakpoints.between("lg", "xl")]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    },
  }
}))

export const ModalBox = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 400,
  maxWidth: '60%',
  padding: '40px',
  backgroundColor: '#fff',
  boxShadow: 24,
  borderRadius: '8px'
}))

export const LinkCustom = styled(Link)(props => ({
  textDecoration: 'none',
  color: '#fff',  
  '&:visited': {
    color: '#fff'
  },
  '&:hover': {
    color: '#fff'
  }
}))

export const LogoImage = ({name, url, size}) => {
  let imgStyle, shortcutStyle;
  
  if(size === 'sm') {
    imgStyle = {
      position: 'relative',
      top: '3px',
      height: '100%',
      borderRadius: '4px',
    }

    shortcutStyle = {
      position: 'relative',
      top: '-1px',
      borderRadius: '4px',
      fontSize: '0.875rem',
      lineHeight: '20px',
    }
  }

  return (
    <>
      {
        !!url ?
          (<img src={url} alt={name} style={{width: '100%', height: '100%', borderRadius: '8px', ...imgStyle}} />) : 
          (<Box
            component="span"
            sx={{
              display: 'inline-block',
              width: '100%',
              height: '100%',
              backgroundColor: `${theme.palette.grey.middle}`,
              borderRadius: '8px',
              color: '#fff',
              fontSize: '2rem',
              fontWeight: 500,
              lineHeight: '56px',
              textAlign: 'center',
              ...shortcutStyle
            }}>
              {name ? name.trim().slice(0,1) : ''}
            </Box>)
      }
    </>
  )
}

export const FullImage = styled('img')({
  width: '100%',
  maxWidth: '360px'
})


export const FlexBoxCenter = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
})

// Popper
export const PopperBoxWrapper = styled(Box)(({theme}) => ({
  margin: '0',
  padding: '8px 0',
  backgroundColor: '#fff',
  border: `1px solid ${theme.palette.grey.light}`,
  borderRadius: '8px',
  boxShadow: theme.shadows[1]
}))

export const MeasuresContainer = styled(Box)(({theme}) => ({
  overflowY: 'auto',
  // maxHeight: '320px', 
  minHeight: '58px',
  margin: '0 0 16px',
  padding: '16px 16px 8px',
  border: `1px solid ${theme.palette.grey.light}`,
  borderRadius: '8px' 
}))

export const OutlinedWrapper = styled(Box)(({theme}) => ({
  margin: '0 0 16px',
  padding: '16px 16px 8px',
  border: `1px solid ${theme.palette.grey.w300}`,
  borderRadius: '4px' 
}))

